import VueI18n from '../../../i18n/i18n';

function createReportList() {
  return [
    {
      id:1,
      label:VueI18n.t('postreportArr.reportList.Spam_and_Abuse'),
      value:"垃圾信息和滥用行为",
    },
    {
      id:2,
      label:VueI18n.t('postreportArr.reportList.Pornographic'),
      value:"色情和不雅内容",
    },
    {
      id:3,
      label:VueI18n.t('postreportArr.reportList.False_Information'),
      value:"虚假信息",
    },
    {
      id:4,
      label:VueI18n.t('postreportArr.reportList.Intellectual'),
      value:"知识产权侵权",
    },
    {
      id:5,
      label:VueI18n.t('postreportArr.reportList.Personal_safety'),
      value:"人身安全和威胁",
    },
    {
      id:6,
      label:VueI18n.t('postreportArr.reportList.Hate_Speech'),
      value:"仇恨言论",
    },
    {
      id:7,
      label:VueI18n.t('postreportArr.reportList.suicide_content'),
      value:"自残或自杀内容",
    },
    {
      id:8,
      label:VueI18n.t('postreportArr.reportList.Account_theft'),
      value:"盗号或欺诈",
    },
    {
      id:9,
      label:VueI18n.t('postreportArr.reportList.Impersonating_someone_else'),
      value:"冒充他人身份",
    },
    {
      id:10,
      label:VueI18n.t('postreportArr.reportList.Harassment_Report'),
      value:"骚扰举报",
    },
    {
      id:11,
      label:VueI18n.t('postreportArr.reportList.Invasion_of_Privacy'),
      value:"侵犯隐私",
    },
    {
      id:12,
      label:VueI18n.t('postreportArr.reportList.Malware_or_links'),
      value:"恶意软件或链接",
    },
    {
      id:13,
      label:VueI18n.t('postreportArr.reportList.Other'),
      value:"其他",
    },
  ];
}

export { createReportList };